const Dashboard: React.FunctionComponent = () => {
  return (
    <>
      <p>This is the Dashboard page.</p>
    </>
  );
};

export { Dashboard };
